import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface InstantGratificationIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isInvertedTheme?: boolean;
  disabled?: boolean;
}

export const InstantGratificationIcon: FunctionComponent<
  InstantGratificationIconProps
> = ({ className, isInvertedTheme, disabled, ...props }) => {
  const theme = useTheme();

  const getBGColor = () => {
    if (disabled) {
      return theme.colors.secondary;
    }

    if (isInvertedTheme) {
      return theme.colors.primary;
    }

    return theme.colors.secondary;
  };

  const getPathColor = () => {
    if (disabled) {
      return theme.colors.tertiary;
    }

    if (isInvertedTheme) {
      return theme.colors.secondary;
    }

    return theme.colors.primary;
  };

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className || ''}
      {...props}
    >
      <circle fill={getBGColor()} cx="8" cy="8" r="8" />
      <path
        fill={getPathColor()}
        fillRule="evenodd"
        d="M11.08,7.24l-4.3-2.63c-.13-.07-.28-.11-.43-.11-.15,0-.3,.04-.43,.12s-.24,.18-.31,.32c-.08,.13-.12,.28-.12,.43v5.26c0,.15,.04,.31,.12,.44,.08,.13,.19,.24,.32,.32s.28,.12,.43,.11c.15,0,.3-.05,.43-.12l4.28-2.63c.13-.08,.23-.19,.31-.32,.07-.13,.11-.28,.11-.43s-.04-.3-.11-.43c-.07-.13-.18-.24-.31-.32Z"
      />
    </svg>
  );
};

export default InstantGratificationIcon;
